<template>
  <div class="row">
    <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <h5>Workshop</h5>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <div class="form-inline ml-auto">
              <div class="button-group">
                <button type="button" class="btn btn-soft-primary btn-sm dropdown-toggle" data-toggle="dropdown">
                  <i class="fa fa-filter" aria-hidden="true"></i>
                    Filter
                    <span class="caret"></span>
                </button>
                <ul class="dropdown-menu p-2" >
                  <span>Status:</span>
                  <div class="dropdown-divider"></div>
                  <li>
                    <a href="#" class="small" tabIndex="-1">
                      <input type="checkbox" value="Accepted" v-model="statusCheck"/>&nbsp; Accepted
                    </a>
                  </li>
                  <li>
                    <a href="#" class="small" tabIndex="-1">
                      <input type="checkbox" value="Ready" v-model="statusCheck"/>&nbsp; Ready
                    </a>
                  </li>
                  <li>
                    <a href="#" class="small" tabIndex="-1">
                      <input type="checkbox" value="Working" v-model="statusCheck"/>&nbsp; Working
                    </a>
                  </li>
                  <li>
                    <a href="#" class="small" tabIndex="-1">
                      <input type="checkbox" value="Updated" v-model="statusCheck"/>&nbsp; Updated
                    </a>
                  </li>
                  <li>
                    <a href="#" class="small" tabIndex="-1">
                      <input type="checkbox" value="Finished" v-model="statusCheck"/>&nbsp; Finished
                    </a>
                  </li>
                  <li>
                    <a href="#" class="small" tabIndex="-1">
                      <input type="checkbox" value="Voided" v-model="statusCheck"/>&nbsp; Voided
                    </a>
                  </li>
                  <div class="dropdown-divider"></div>
                  <span>Service Type:</span>
                  <div class="dropdown-divider"></div>
                  <li v-for="wt in workshopTypeList" :key="wt.id">
                    <a href="#" class="small" tabIndex="-1">
                      <input type="checkbox" :value="wt.id" v-model="typeCheck"/>&nbsp; {{ wt.name }}
                    </a>
                  </li>
                </ul>
                <button type="button" class="btn btn-sm btn-soft-primary waves-light waves-effect" @click="addWorkshop">
                  <i class="fa fa-plus" aria-hidden="true"></i> New
                </button>
                <button type="button" class="btn btn-sm btn-soft-primary waves-light waves-effect" @click="refreshList">
                  <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                </button>
                rows:
                <select id="select-rows" v-model="pageSize" @change="setPageSizeOnChange">
                  <option v-for="r in rowsTable" :key="r.row" :value="r.row">{{ r.row }}</option>
                </select>
                <span class="mr-1">
                  Total rows: <b>{{ rowsTotal }}</b>
                </span>
                <date-picker v-model="startDate" type="date" range placeholder="Select date range" @change="refreshList"></date-picker>
              </div>

              <div class="form-group mx-sm-3 mb-2">
                <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery"/>
              </div>
              <span class="mr-1">
                page:
                <select v-model="currentPage">
                  <option v-for="p in pageLength" :key="p" :value="p">{{ p }}</option>
                </select>
                / {{ pageLength }}
              </span>
              <nav aria-label="Page navigation example" class="pull-right">
                <ul class="pagination">
                  <li class="page-item">
                    <a class="btn btn-default btn-sm" href="javascript:void(0)" @click="prevPage">
                      <i class="fa fa-angle-left" aria-hidden="true"></i>
                    </a>
                  </li>
                  <li class="page-item">
                    <a class="btn btn-default btn-sm" href="javascript:void(0)" @click="nextPage">
                      <i class="fa fa-angle-right" aria-hidden="true"></i>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
            <table class="table table-item mb-0 table-sm">
              <thead>
                <tr>
                  <th>
                    <label class="form-checkbox">
                      <input type="checkbox" v-model="selectAll" @click="select"/>
                      <i class="form-icon"></i>
                    </label>
                  </th>
                  <th v-for="t in title" v-bind:key="t.prop" @click="sortTable(t.prop)">
                    {{ t.name }}
                    <div class="float-right fa" v-if="t.prop == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                  </th>
                  <th>#</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="filterData.length < 1">
                  <td colspan="12" style="text-align: center"><i>No Data</i></td>
                </tr>
                <tr v-for="u in filterData" v-bind:key="u.id">
                  <td>
                    <label class="form-checkbox"><input type="checkbox" :value="u.id" v-model="selected" /><i class="form-icon"></i></label>
                  </td>
                  <td>
                    <span class="badge badge-info" v-if="u.status === 'open'">{{ u.status }}</span>
                    <span class="badge badge-primary" v-else-if="u.status === 'approve'">{{ u.status }}</span>
                    <span class="badge badge-warning" v-else-if="u.status === 'on progress'">{{ u.status }}</span>
                    <span class="badge badge-success" v-else-if="u.status === 'finish'">{{ u.status }}</span>
                    <span class="badge badge-danger" v-else-if="u.status === 'void'">{{ u.status }}</span>
                    <span class="badge badge-secondary" v-else>{{ u.status }}</span>
                  </td>
                  <td @click="editWorkshop(u.id)"><b class="text-ref-sales">{{ u.workshop_no }}</b></td>
                  <td><b>{{ u.customer.name }}</b></td>
                  <td>{{ u.mechanic }}</td>
                  <td>{{ u.workshop_type.name }}</td>
                  <td>{{ u.date_in | dateFormat('DD/MM/YYYY') }}</td>
                  <td>{{ u.schedule_date | dateFormat('DD/MM/YYYY')}}</td>
                  <td>{{ u.work_start | dateFormat('DD/MM/YYYY H:m:s') }}</td>
                  <td>{{ u.work_finish | dateFormat('DD/MM/YYYY H:m:s') }}</td>
                  <td>{{ u.hours }}</td>
                  <td>
                    <span v-if="u.sale_no !== null"><i class="fa fa-check" style="color: green;"></i></span>
                    <span v-else></span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- <pre>
      {{ statusCheck }}
    </pre> -->
    <!-- <pre>
      {{ filterData }}
    </pre> -->
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { workshopUrl, getHeader } from '@/config'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import DatePicker from 'vue2-datepicker'

export default {
  name: 'WorkshopList',
  components: {
    Loading,
    DatePicker
  },
  data () {
    var date = new Date()
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    return {
      startDate: [date1, date2],
      dateNow: new Date(),
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      dataRaw: [],
      data: {},
      searchQuery: '',
      ascending: false,
      sortClick: false,
      sortColumn: '',
      pageSize: 10,
      currentPage: 1,
      title: [{
        name: 'Status',
        prop: 'status'
      }, {
        name: 'Workshop Number',
        prop: 'workshop_no'
      }, {
        name: 'Customer',
        prop: 'customer.name'
      }, {
        name: 'Mechanic',
        prop: 'mechanic'
      }, {
        name: 'Service Type',
        prop: 'type_id'
      }, {
        name: 'Date',
        prop: 'date_in'
      }, {
        name: 'Schedule',
        prop: 'schedule_date'
      }, {
        name: 'Start',
        prop: 'work_start'
      }, {
        name: 'Finish',
        prop: 'work_end'
      }, {
        name: 'Work Hours',
        prop: 'hours'
      }, {
        name: 'Invoice',
        prop: 'sale_no'
      }],
      selectAll: false,
      selected: [],
      statusCheck: [],
      typeCheck: []
    }
  },
  mounted () {
    this.refreshList()
  },
  computed: {
    ...mapState({
      rowsTable: (state) => state.data.rowsTable,
      workshopTypeList: (state) => state.workshopTypes.workshopTypeList
    }),
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw
        .sort(function (a, b) {
          if (a[col] > b[col]) {
            return ascending ? 1 : -1
          } else if (a[col] < b[col]) {
            return ascending ? -1 : 1
          }
          return 0
        }).filter(d => {
          if (this.typeCheck.length > 0) {
            for (let i = 0; i < this.typeCheck.length; i++) {
              if (d.type_id === this.typeCheck[i]) {
                return d
              }
            }
          } else {
            return d
          }
        }).filter(d => {
          if (this.statusCheck.length > 0) {
            for (let i = 0; i < this.statusCheck.length; i++) {
              if (d.status === this.statusCheck[i]) {
                return d
              }
            }
          } else {
            return d
          }
        }).filter((d) => {
          for (const name in d) {
            if (d[name] !== null) {
              if (
                d[name]
                  .toString()
                  .toLowerCase()
                  .indexOf(this.searchQuery.toLowerCase()) > -1
              ) {
                return d
              }
            }
          }
        })
        .filter((row, index) => {
          const start = (this.currentPage - 1) * this.pageSize
          const end = this.currentPage * this.pageSize
          if (index >= start && index < end) return true
        })
    }
  },
  methods: {
    teknisiForm: function (id) {
      axios.get(workshopUrl + '/' + id, { headers: getHeader() })
        .then((response) => {
          this.$emit('viewRo', response.data.data)
        })
        .catch((response) => {
          console.log(response.response)
          this.$swal('Error!!!', response, 'error')
        })
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if (this.currentPage * this.pageSize < this.dataRaw.length) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    editWorkshop (id) {
      axios
        .get(workshopUrl + '/' + id, { headers: getHeader() })
        .then((response) => {
          this.$emit('editWorkshop', response.data.data)
        })
        .catch((response) => {
          this.$swal('Error!!!', response, 'error')
        })
    },
    addWorkshop () {
      this.$emit('newWorkshop', true)
    },
    refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var url = workshopUrl + '?begin=' + begin + '&end=' + end
      axios
        .get(url, { headers: getHeader() })
        .then((response) => {
          console.log(response)
          this.dataRaw = response.data.data
          this.$Progress.finish()
          this.loader.isLoading = false
          this.currentPage = 1
          this.searchQuery = ''
        })
        .catch((error) => {
          this.loader.isLoading = false
          if (error === 'Error: Network Error') {
            window.localStorage.removeItem('authUser')
            this.$router.push({ name: 'login' })
          } else if (
            error.response.data.message === 'This action is unauthorized.'
          ) {
            window.localStorage.removeItem('authUser')
            this.$router.push({ name: 'login' })
          }
        })
    }
  }
}
</script>
